import { EXPRESSION_TYPES } from '@willow/types-iso';

import { functionFrom, FunctionLibrary, getFunctionSignature, spreadParam } from '../FunctionDefinition';

const concat = functionFrom(
  'concat',
  spreadParam({ name: 'str', type: EXPRESSION_TYPES.string }),
  EXPRESSION_TYPES.string,
  (_ctx, ...strs) => strs.join(''),
  'Concatenates any number of strings into a single string.',
);

export const STRING_FUNCTIONS = {
  [getFunctionSignature(concat)]: concat,
} satisfies FunctionLibrary;
